export const getUrlParam = (name, search) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  if(!search){
    search = window.location.search
  }
  const r = search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

// 将inviteCode写入cookie，24小时过期
export function storeInviteCodeInCookie(inviteCode) {
  // 计算cookie的有效期（以小时为单位）
  const hoursToExpire = 24;

  // 计算过期日期
  const expirationDate = new Date();
  expirationDate.setTime(expirationDate.getTime() + (hoursToExpire * 60 * 60 * 1000));

  // 设置cookie
  document.cookie = `inviteCode=${inviteCode}; expires=${expirationDate.toUTCString()}; domain=.800best.com; path=/`;
}
